module.exports = __webpack_public_path__ + "static/img/KV_zh@3x.fcbe781.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/KV_zh@3x.png
// module id = tXtP
// module chunks = 1